import { render, staticRenderFns } from "./projectPlaza.vue?vue&type=template&id=168e44f5"
import script from "./projectPlaza.vue?vue&type=script&lang=js"
export * from "./projectPlaza.vue?vue&type=script&lang=js"
import style0 from "./projectPlaza.vue?vue&type=style&index=0&id=168e44f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports